import React from 'react';

const PaperTabletActiveIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M18.75 3H15.3469C14.9265 2.52783 14.4109 2.14996 13.8341 1.89121C13.2573 1.63246 12.6322 1.49869 12 1.49869C11.3678 1.49869 10.7427 1.63246 10.1659 1.89121C9.58908 2.14996 9.07353 2.52783 8.65313 3H5.25C4.85218 3 4.47064 3.15804 4.18934 3.43934C3.90804 3.72064 3.75 4.10218 3.75 4.5V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H18.75C19.1478 21.75 19.5294 21.592 19.8107 21.3107C20.092 21.0294 20.25 20.6478 20.25 20.25V4.5C20.25 4.10218 20.092 3.72064 19.8107 3.43934C19.5294 3.15804 19.1478 3 18.75 3ZM12 3C12.7949 3.00247 13.5565 3.31934 14.1186 3.88141C14.6807 4.44349 14.9975 5.20511 15 6H9C9.00247 5.20511 9.31934 4.44349 9.88141 3.88141C10.4435 3.31934 11.2051 3.00247 12 3ZM15 15H9C8.80109 15 8.61032 14.921 8.46967 14.7803C8.32902 14.6397 8.25 14.4489 8.25 14.25C8.25 14.0511 8.32902 13.8603 8.46967 13.7197C8.61032 13.579 8.80109 13.5 9 13.5H15C15.1989 13.5 15.3897 13.579 15.5303 13.7197C15.671 13.8603 15.75 14.0511 15.75 14.25C15.75 14.4489 15.671 14.6397 15.5303 14.7803C15.3897 14.921 15.1989 15 15 15ZM15 12H9C8.80109 12 8.61032 11.921 8.46967 11.7803C8.32902 11.6397 8.25 11.4489 8.25 11.25C8.25 11.0511 8.32902 10.8603 8.46967 10.7197C8.61032 10.579 8.80109 10.5 9 10.5H15C15.1989 10.5 15.3897 10.579 15.5303 10.7197C15.671 10.8603 15.75 11.0511 15.75 11.25C15.75 11.4489 15.671 11.6397 15.5303 11.7803C15.3897 11.921 15.1989 12 15 12Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default PaperTabletActiveIcon;
